import deduplication_manager from '@/js/utilities/deduplication-manager.js';
import store from './';

store.subscribe( (mutation) => {
	const { type } = mutation;
	if(type.search('application') >= 0 && type.search('importState') === -1){

		if(!deduplication_manager.checkAgainstStore(mutation)){
			// Deduplicate mutations to break infinite loop
			store.dispatch('application/trafficControl', mutation);
		} else {
			// Filtered
		}
	}
})
